<template>
	<header
		class="flex justify-between items-center pt-4 md:pt-8 px-4 md:px-8 xl:px-16"
	>
		<img class="w-32 sm:w-56" src="/images/logo.png" alt="logo" />
		<NavButton
			:icon="activeLanguage?.flag"
			:text="activeLanguage?.two_digit_code"
			:icon_alt="`Flag of ${activeLanguage?.title}`"
			icon_size="20"
			icon_classes="h-full py-2.5"
			text_classes="uppercase"
			is_language_flag
			:onClick="toggleLanguageModal"
		/>
		<LanguageModal
			v-if="show_language_modal"
			:toggleLanguageModal="toggleLanguageModal"
			class="fixed -top-4 -left-4 h-screen-dynamic w-screen-dynamic"
		/>
	</header>
</template>

<script>
import { NavButton, LanguageModal } from "@/components/ui";
import { mapGetters } from "vuex";
export default {
	name: "HomeHeader",
	computed: {
		...mapGetters("languages", ["activeLanguage"]),
	},
	components: {
		LanguageModal,
		NavButton,
	},
	props: {
		show_language_modal: {
			type: Boolean,
			required: true,
		},
		toggleLanguageModal: {
			type: Function,
			required: true,
		},
	},
};
</script>
